import { render } from "./wares-record.vue?vue&type=template&id=4f534421"
import script from "./wares-record.vue?vue&type=script&lang=js"
export * from "./wares-record.vue?vue&type=script&lang=js"

import "./wares-record.vue?vue&type=style&index=0&id=4f534421&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__